// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GuestLazyComponent" + "." + "c0b4e3cb10f80816c8da" + ".js";
};